// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ma-0";
export var assigneeDetails = "_ma-1";
export var assigneeInfo = "_ma-2";
export var dropdownContainer = "_ma-4";
export var dropdownImage = "_ma-5";
export var editAssigneeInfo = "_ma-3";
export var editAssigneeModalContainer = "_ma-6";
export var hidden = "_ma-8";
export var input = "_ma-7";